import { render, staticRenderFns } from "./PurchaseRecord.vue?vue&type=template&id=6fe11f37&scoped=true"
import script from "./PurchaseRecord.vue?vue&type=script&lang=js"
export * from "./PurchaseRecord.vue?vue&type=script&lang=js"
import style0 from "./PurchaseRecord.vue?vue&type=style&index=0&id=6fe11f37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe11f37",
  null
  
)

export default component.exports